import GlobalPay from './GlobalPay';

export default GlobalPay;
